import { TFunction } from 'i18next'
import * as yup from 'yup'
export const UpdateTicketSchema = (t: TFunction<'translation', undefined>) =>
    yup.object().shape({
        ticket_type_id: yup
            .number()
            .required(t('blank-errors'))
            .moreThan(0, t('Ticket type is required and must be a number')),
    })
